import ReturnsRmaModal from './ReturnsRmaModal';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import { returnsActions, returnErrorSel } from 'src/store/modules/returns';
import {
  IReturnSubmittedOption,
  IReturnEditedOption,
  IStatusFilter,
  IReturnGenerateShippingLabel
} from 'src/services/returns/typings';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: IInitialState) => ({
  error: returnErrorSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  onSubmitAfterEditRmaList: (
    config: IReturnSubmittedOption,
    callback?: () => void
  ) => {
    dispatch(returnsActions.onSubmitAfterEditRmaList(config, callback));
  },

  onSaveAfterEditRmaList: (
    config: IReturnEditedOption,
    callback?: () => void
  ) => {
    dispatch(returnsActions.onSaveAfterEditRmaList(config, callback));
  },

  getStatusItems: (body?: IStatusFilter) => {
    dispatch(returnsActions.getStatusItems(body));
  },

  onGenerateShippingLabel: (upsRequest: IReturnGenerateShippingLabel, callback?: () => void) => {
    dispatch(returnsActions.onGenerateShippingLabel(upsRequest, callback));
  },

  getRMALists: (body?: IStatusFilter) => {
    dispatch(returnsActions.getRMALists(body));
  },
  clearError: () => {
    dispatch(
      returnsActions.setReturnError({
        hasError: false,
        message: '',
        status: null
      })
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(ReturnsRmaModal));
